import { Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard';

const DashboardRouting = () => {
  return (
    <Routes>
      <Route path='' element={<Dashboard />} />
    </Routes>
  );
};

export default DashboardRouting;
